"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _utils_1 = require("@utils");
const ArticleTeaserOverlap_1 = require("./ArticleTeaserOverlap"); // Component
var ArticleTeaserCenter = function ArticleTeaserCenter(_ref) {
    var eyebrowLabel = _ref.eyebrowLabel, title = _ref.title, description = _ref.description, url = _ref.url, heroImageUrl = _ref.heroImageUrl;
    return /*#__PURE__*/ react_1.default.createElement(StyledWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledImageSet, null, /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ImageWrapper, null, /*#__PURE__*/ react_1.default.createElement(StyledTeaserImage, {
        src: heroImageUrl,
        objectFit: "cover",
        widthClass: "bodyMargin",
        alt: title
    })), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.BoxShadow, null)), /*#__PURE__*/ react_1.default.createElement(StyledCopy, null, eyebrowLabel && /*#__PURE__*/ react_1.default.createElement(atoms_1.EyebrowLabel, {
        alignment: "center"
    }, eyebrowLabel), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Header, {
        dangerouslySetInnerHTML: {
            __html: title
        }
    }), /*#__PURE__*/ react_1.default.createElement(StyledSubhead, {
        dangerouslySetInnerHTML: {
            __html: description
        }
    }), /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Rule, null), /*#__PURE__*/ react_1.default.createElement(StyledButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.StyledButton, {
        to: url,
        type: "black",
        shadow: true,
        size: "large"
    }, "Read more", /*#__PURE__*/ react_1.default.createElement("span", {
        className: "seoCopy"
    }, " about ", title)))), /*#__PURE__*/ react_1.default.createElement(atoms_1.LinkMask, {
        to: url
    }, title));
};
var StyledWrapper = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Wrapper, props);
}).withConfig({
    displayName: "ArticleTeaserCenter__StyledWrapper",
    componentId: "s29h4m-0"
})(["@media only screen and (min-width:768px){flex-direction:column;}"]);
var StyledImageSet = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ImageSet, props);
}).withConfig({
    displayName: "ArticleTeaserCenter__StyledImageSet",
    componentId: "s29h4m-1"
})(["", "{position:relative;left:0px;width:100%;height:480px;}", "{width:100%;height:600px;}", "{width:100%;height:720px;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledTeaserImage = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.TeaserImage, props);
}).withConfig({
    displayName: "ArticleTeaserCenter__StyledTeaserImage",
    componentId: "s29h4m-2"
})(["", "{transform:scale3d(1.045,1.045,1) !important;transition:opacity 0.5s ease-in-out,transform 2s ease-in-out !important;", ":hover &{transform:scale3d(1,1,1) !important;}}"], _utils_1.mediaQuery('tablet'), StyledWrapper);
var StyledCopy = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Copy, props);
}).withConfig({
    displayName: "ArticleTeaserCenter__StyledCopy",
    componentId: "s29h4m-3"
})(["", "{width:600px !important;padding:40px 40px 0 40px !important;margin:-120px 0 0 0 !important;text-align:center !important;}", "{width:680px !important;padding-bottom:0 !important;margin:-160px auto 0 auto !important;}", "{width:768px !important;padding-bottom:0 !important;margin:-200px auto 0 auto !important;}"], _utils_1.mediaQuery('tablet'), _utils_1.mediaQuery('laptop'), _utils_1.mediaQuery('desktop'));
var StyledSubhead = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.Subhead, props);
}).withConfig({
    displayName: "ArticleTeaserCenter__StyledSubhead",
    componentId: "s29h4m-4"
})(["", "{", ":hover &{transform:translate3d(0,4px,0) !important;}}"], _utils_1.mediaQuery('tablet'), StyledWrapper);
var StyledButtonWrapper = styled_components_1.default(function (props) {
    return /*#__PURE__*/ react_1.default.createElement(ArticleTeaserOverlap_1.ButtonWrapper, props);
}).withConfig({
    displayName: "ArticleTeaserCenter__StyledButtonWrapper",
    componentId: "s29h4m-5"
})(["", "{justify-content:center !important;}"], _utils_1.mediaQuery('tablet'));
exports.default = ArticleTeaserCenter;
